import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  name: "new_link_line_oa",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("input", {
  name: "new_name_line",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import ToolsUpload from '../../tools/Upload.vue'
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'

import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateLineOa',
  setup(__props) {

const store = useStore()
const getExampleImage = () =>{
  const baseUrl = window.location.origin
  return `${baseUrl}/ticket-example/รูปตัวอย่าง เปลี่ยน line OA.png`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.operatorName')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"])
      ]),
      _createElementVNode("input", {
        value: _unref(store).state.selectedOperator.name,
        name: "operator_name",
        type: "text",
        class: "w-full rounded-md",
        disabled: true
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.newLinkLineOa')) + " ", 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.newNameLine')) + "@ ", 1),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_9
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})